<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import { getCollapseClass } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    disable = [],
    isCollapsable = false,
    isCollapsed = false;

  let isBrandCollapsed = true;

  let toggleCollapse = () => {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  };

  let toggleBrandCollapse = () => {
    isBrandCollapsed = !isBrandCollapsed;
  };

  data.style.color = data.style.color || "#969AA1";
  data.style.brandColor = data.style.brandColor || "#969AA1";
  data.style.brandingPosition = data.style.brandingPosition || "top";
  $: if (data.label.trim() === "") data.label = M.UNSUBSCRIBE;
</script>

<div class="col20 f-left t-center mt-15 email-styling-wrapper" on:click={toggleCollapse}>
  <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.UNSUBSCRIBE}</h4>
</div>
{#if !isCollapsed}
  <div class="section">
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.color} label={M.COLOR} alpha="no" />
    </div>

    <div class="info">
      <span>{M.TEXT_WIDGET_NAME}</span>
    </div>
    <div class="right-side">
      <input bind:value={data.label} type="text" class="transition-border" />
    </div>
    {#if disable.indexOf("align") === -1}
      <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">{M.ALIGNMENT}</h5>
        <select bind:value={data.style.position}>
          <option value="left">{M.LEFT}</option>
          <option value="center">{M.CENTER}</option>
          <option value="right">{M.RIGHT}</option>
        </select>
      </div>
    {/if}
  </div>
{/if}

<div class="col20 f-left t-center mt-15 email-styling-wrapper" on:click={toggleBrandCollapse}>
  <h4 class="t-left {getCollapseClass(true, isBrandCollapsed)}">{M.BRAND_DETAILS}</h4>
</div>

{#if !isBrandCollapsed}
  <div class="section">
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.brandColor} label={M.COLOR} alpha="no" />
    </div>
    {#if disable.indexOf("brandingPosition") === -1}
      <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">{M.POSITION}</h5>
        <select bind:value={data.style.brandingPosition}>
          <option value="top">{M.TOP}</option>
          <option value="left">{M.LEFT}</option>
        </select>
      </div>
    {/if}
  </div>
{/if}

<BlockGlobal bind:data disable={disable} isCollapsable={true} isCollapsed={true} />
